import { Colors } from "../../../consts/Colors";
import ButtonRounded from "../../global/buttons/ButtonRounded";
import QuestionPanel from "./QuestionPanel";

export default class QuestionPanel_2 extends QuestionPanel {
    constructor(scene, x, y, {config, totQuestion}) {
        super(scene, x, y, {
            numquestion: 2,
            totQuestion,
            question: config.question,
            textIndice: config.indice
        });

        this.config = config
        this.buttons = []

        let Y = this.sousTitreText.y + this.sousTitreText.height + 24

        // Ajout boutons reponses
        config.reponses.forEach(reponse => {
            let button = new ButtonRounded(this.scene,  this.width/2, 0, {
                width: 410, 
                height: 84,
                text: reponse.text,
                color: Colors.Elmt.Orange,
                hoverColor: Colors.Elmt.Blue
            })
            button.isTrue = reponse.isTrue
            button.y = Y + button.height/2
            Y = button.y + button.height/2 + 16
            this.add(button)
            this.buttons.push(button)
            button.setClickFunction((elmt) => {
                this.checkResponse(elmt)
            })

        });

    }

    setLocked(){
        super.setLocked();
        this.inputText.setLocked();
        this.validateButton.setLocked();
    }

    setUnlocked(){
        super.setUnlocked();
        this.inputText.setUnlocked();
        this.validateButton.setUnlocked();
    }

    checkResponse(elmt){
        // On parcours les boutons et on met en forme
        var isTrue = true 
        this.buttons.forEach((button) => {
            button.disableInteractive()
            this.scene.input.setDefaultCursor('default')

            if(button.isTrue){
                this.setButtonTrue(button)
            }else if(!button.isTrue && button == elmt){
                this.setButtonFalse(button)
                isTrue = false
            }else{
                this.setButtonLocked(button)
            }
        })
        
        this.scene.showReponsePopUp({
            text: this.config.correction,
            isTrue: isTrue,
            endFunc: () => {
                this.scene.closePanelQuestion((scene) => {scene.addQuestionPanel3();});
                this.scene.closeReponsePopUp();
            }
        });
    }

    setButtonTrue(button){
        button.background.setFillStyle(Colors.Elmt.Green)
    }

    setButtonFalse(button){
        button.background.setFillStyle(Colors.Elmt.White, 0)
        button.background.setStrokeStyle(4, Colors.Elmt.Red)

        button.textElmt.text = '<class=\"red_crossed\">' + button.textElmt.text + '</class>'
    }

    setButtonLocked(button){
        button.background.setFillStyle(Colors.Elmt.Grey)
    }
}